import React, {useState} from "react";
import {connect} from "react-redux";
import Form from "./CreateCustomerForm";
import {fromJS, Map} from "immutable";
import {validatePresence} from "../../lib/Validators";
import {cancelCreateCustomer} from "../../actions/AccountApiActions";
import {createErrors, createValidationErrors} from "../../lib/ErrorFormatter";
import gql from "graphql-tag";
import {compose} from "redux";
import {graphql} from "react-apollo";
import {DEFAULT_LOCALE, localeNameFromCode, SUPPORTED_LOCALES} from "../../lib/Locales";

function validateForm(values) {
  let errors = Map();
  errors = validatePresence(errors, values, "name");
  errors = validatePresence(errors, values, "email");
  errors = validatePresence(errors, values, "locale");
  // errors = validatePresence(errors, values, "phone");
  return errors.toJS();
}

const CreateCustomerFormContainer = (props) => {

  const [errors, setErrors] = useState([]);

  const handleSubmit = (values) => {
    return props.createCustomer(values.toJS())
      .then((response) => {
        if (response.data.createCustomer.errors.length <= 0) {
          props.cancelCreateCustomer();
        } else {
          setErrors(createValidationErrors(response.data.createCustomer.errors));
        }
      })
      .catch((err) => {
        setErrors(createErrors(err));
      });
  }
  const handleCancel = props.cancelCreateCustomer;

  const locales = fromJS(SUPPORTED_LOCALES.map(
    (code) => ({value: code, title: localeNameFromCode(code)})
  ));

  return (
    <Form
      errors={errors}
      validate={validateForm}
      onSubmit={handleSubmit}
      onCancel={handleCancel}
      initialValues={fromJS({locale: DEFAULT_LOCALE})}
      availableLocales={locales}
      />
  );
}

const CREATE_CUSTOMER = gql`
  mutation createCustomer($data: NewCustomerInput!) {
    createCustomer(input: $data) {
      errors { key message }
    }
  }
`;

const withMutation = compose(
  graphql(CREATE_CUSTOMER, {
    props: ({ mutate }) => ({
      createCustomer: (data) => mutate({
        variables: { data: data }
      })
    })
  }),
);

export default connect(null, {cancelCreateCustomer})(withMutation(CreateCustomerFormContainer));